/* eslint-disable consistent-return */
import { createAsyncThunk } from '@reduxjs/toolkit';
import create from '../../../services/api';
import API_PATH from '../../../constant/apiPath';
import { updateLoading } from '../loader';

// Define handleSupport thunk
const handleSupport = createAsyncThunk('support/handleSupport', async (data: any, { dispatch }) => {
  const API = create();
  try {
    dispatch(updateLoading(true));
    const response:any = await API.post(API_PATH.SUPPORT, data); // Adjust `any` to the correct type if known
    dispatch(updateLoading(false));
    return response.data;
  } catch (err) {
    dispatch(updateLoading(false));
    return Promise.reject(err); // Return as rejected promise
  }
});

export {
  handleSupport,
};